export default __webpack_public_path__ + "static/section4-image-6db5f2731aba3af2609cee5df8817eee.webp";